import type { Option } from './interface';

// 默认键背景色
export const defaultKeyBgColor = '#363636';
// 默认值背景色
export const defaultValBgColor = '#175e9c';

// 默认配置项
export const defaultOption: Option = { keyBgColor: defaultKeyBgColor, valBgColor: defaultValBgColor };
